var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomMenuHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6A0DAD;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_9-Home"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.1,480H162.9c-43.8,1.6-80.8-32.3-82.9-76.2V304c0-8.8,7.2-16,16-16s16,7.2,16,16v99.8 c2,26.1,24.7,45.8,50.9,44.2h186.2c26.2,1.7,48.8-18,50.9-44.2V304c0-8.8,7.2-16,16-16s16,7.2,16,16v99.8 C429.9,447.7,393,481.6,349.1,480z M475.4,267.4c6.3-6.2,6.3-16.4,0.1-22.6c0,0-0.1-0.1-0.1-0.1l-208-208 c-6.2-6.3-16.4-6.3-22.6-0.1c0,0-0.1,0.1-0.1,0.1l-208,208c-6.3,6.3-6.3,16.4,0,22.7s16.4,6.3,22.7,0L256,70.6l196.6,196.8 C458.9,273.6,469,273.7,475.4,267.4C475.3,267.4,475.3,267.4,475.4,267.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomMenuHomeActive);
export default __webpack_public_path__ + "static/media/bottomMenuHomeActive.f24e2e2751b97e7c89809bc79ddede54.svg";
export { ForwardRef as ReactComponent };